import { useId } from 'react'
import type { AdminSource } from '../types/admin'

const tokenFormat = new Intl.NumberFormat('en-US')
const costFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 4, maximumFractionDigits: 4 })

export default function ExtractionUsage({ usage }: { usage: AdminSource['extraction_usage'] }) {
  const id = useId()
  const metrics = [
    { label: 'Input tokens', value: usage.input_tokens === null ? null : tokenFormat.format(usage.input_tokens) },
    { label: 'Output tokens', value: usage.output_tokens === null ? null : tokenFormat.format(usage.output_tokens) },
    { label: 'Estimated cost (USD)', value: usage.cost_usd === null ? null : costFormat.format(usage.cost_usd) },
  ]

  return <section aria-labelledby={id} className="mb-8 rounded-xl border border-line bg-soft p-6">
    <h2 id={id} className="font-serif text-xl">Last extraction usage</h2>
    <p className="mt-2 text-xs leading-6 text-muted">Totals for the latest pass 1 and pass 2 extraction. Cost is an estimate.</p>
    <dl className="mt-5 grid gap-5 sm:grid-cols-3">
      {metrics.map(({ label, value }) => <div key={label} className="min-w-0">
        <dt className="text-xs font-medium text-muted">{label}</dt>
        <dd className={`mt-2 break-words ${value === null ? 'text-sm text-muted' : 'font-mono text-xl tabular-nums text-ink'}`}>{value ?? 'Not recorded'}</dd>
      </div>)}
    </dl>
  </section>
}
